<!--
 * @Author: DY
 * @Date: 2024-11-20 18:46:12
 * @LastEditTime: 2025-04-25 16:45:56
 * @Description: 监盘确认表单
 * @FilePath: \ShiMo_Mobile\src\views\storage\monitorTheInventoryConfirm\form.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="monitorTheInventoryConfirmForm commonFormStyles">
            <HeaderNav
                header-title="监盘确认表单"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <ul class="formList" :class="{'formList_Readonly' : isReadonly}">
                <li>
                    <van-cell
                        title="盘点编号"
                        :value="formData.CheckNo"
                        :icon="require('@/assets/images/icons/icon_28@2x.png')"
                    ></van-cell>
                </li>
                <li>
                    <van-cell
                        title="库位编码"
                        :value="formData.GridCode"
                        :icon="require('@/assets/images/icons/icon_34@2x.png')"
                    ></van-cell>
                </li>
                <li>
                    <van-cell
                        title="库位名称"
                        :value="formData.GridName"
                        :icon="require('@/assets/images/icons/icon_5@2x.png')"
                    ></van-cell>
                </li>
                <li>
                    <van-cell
                        title="仓库名称"
                        :value="formData.StockName"
                        :icon="require('@/assets/images/icons/icon_47@2x.png')"
                    ></van-cell>
                </li>
                <li>
                    <dl class="materialItem" v-for="(item, index) in formData.materials" :key="`material_${index}`">
                        <dt>
                            <p>物料代码：{{ item.MaterialCode }}</p>
                            <p>短描述：{{ item.MaterialShortName }}</p>
                            <p>单位：{{ item.Unit }}</p>
                        </dt>
                        <dd>
                            <div>
                                <h5>盘点前库存</h5>
                                <p>{{ item.VolumeCurrent }}</p>
                            </div>
                            <div>
                                <h5>盘点后库存</h5>
                                <p>{{ item.VolumeCheck }}</p>
                            </div>
                            <div :class="{'difference': (item.VolumeDiffer || 0) != 0}">
                                <h5>库存差异</h5>
                                <p>{{ item.VolumeDiffer }}</p>
                            </div>
                        </dd>
                    </dl>
                </li>
                <li>
                    <van-cell
                        title="期间入库"
                        :value="formData.DuringInStockVolume"
                        :icon="require('@/assets/images/icons/icon_6@2x.png')"
                    ></van-cell>
                </li>
                <li>
                    <van-cell
                        title="期间出库"
                        :value="formData.DuringOutStockVolume"
                        :icon="require('@/assets/images/icons/icon_6@2x.png')"
                    ></van-cell>
                </li>
                <li>
                    <van-cell
                        title="最大库存"
                        :value="formData.VolumeMax"
                        :icon="require('@/assets/images/icons/icon_6@2x.png')"
                    ></van-cell>
                </li>
                <li>
                    <van-cell
                        title="盘点人"
                        :value="formData.CheckUserName"
                        :icon="require('@/assets/images/icons/icon_8@2x.png')"
                    ></van-cell>
                </li>
                <li>
                    <van-cell
                        title="盘点时间"
                        :value="formData.CheckTime"
                        :icon="require('@/assets/images/icons/icon_7@2x.png')"
                    ></van-cell>
                </li>
                <li>
                    <van-cell
                        title="监盘人"
                        :value="formData.ConfirmUserName"
                        :icon="require('@/assets/images/icons/icon_8@2x.png')"
                    ></van-cell>
                </li>
                <li>
                    <van-cell
                        title="确认时间"
                        :value="formData.ConfirmTime"
                        :icon="require('@/assets/images/icons/icon_7@2x.png')"
                    ></van-cell>
                </li>
                <li>
                    <van-field
                        label="说明"
                        type="textarea"
                        :rows="2"
                        :disabled="isReadonly"
                        :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                        v-model="formData.Remarks"
                    ></van-field>
                </li>
            </ul>
            <footer class="currencyFooterStyle" v-if="!isReadonly">
                <button class="confirm" @click="confirmConfirmFormInfo">
                    扫码确认
                </button>
                <button class="confirm" @click="returnConfirmFormInfo">
                    退回
                </button>
                <button class="confirm" @click="saveRemarks">
                    保存
                </button>
            </footer>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
export default {
    // 库位表单
    name: 'monitor-the-inventory-confirm-form',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/monitorTheInventoryConfirm') {
            this.$store.commit('noKeepAlive', 'monitor-the-inventory-confirm-form');
        }
        next();
    },
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            isReadonly: false,
            formData: {},
        };
    },
    computed: {},
    watch: {},
    activated() {},
    created() {
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },

        async initpage() {
            window.jyCallback_DriveScanFinished = this.jyCallback_DriveScanFinished_jpqr;
            if (this.$route.params.type === 'maintain') {
                if (this.$route.params.data.Status !== 1) {
                    this.isReadonly = true;
                }
                this.formData = await this.getConfirmFormInfoRequrst(this.$route.params.data.Id);
            }
        },

        async confirmConfirmFormInfo() {
            this.$callMobile('JYExternalNative', 'jyDriveScanClick');
        },

        async jyCallback_DriveScanFinished_jpqr(val) {
            const data = JSON.parse(`${val}`.slice(1, -1));
            if (this.formData.GridCode === data.grid_code) {
                const res = await this.confirmConfirmFormInfoRequrst(this.formData.Id, this.formData.DuringInStockVolume, this.formData.DuringOutStockVolume);
                if (res) {
                    this.$toast.success('确认成功');
                    setTimeout(() => {
                        this.closeAllocationForm();
                    }, 1000);
                }
            } else {
                this.$toast.fail('请扫描正确的库位');
            }
        },

        async returnConfirmFormInfo() {
            const res = await this.returnConfirmFormInfoRequrst(this.formData.Id);
            if (res) {
                this.$toast.success('退回成功');
                this.closeAllocationForm();
            }
        },

        async saveRemarks() {
            const res = await this.saveRemarksRequrst(this.formData.Id, this.formData.Remarks);
            if (res) {
                this.$toast.success('保存成功');
            }
        },

        closeAllocationForm() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'monitorTheInventoryConfirm',
                params: {
                    saveCallback: true,
                },
            });
        },

        getConfirmFormInfoRequrst(id) {
            return this.$axios.$get(`/interfaceApi/procurement/stock_grid_check/get/${id}`);
        },

        confirmConfirmFormInfoRequrst(id, DuringInStockVolume, DuringOutStockVolume) {
            return this.$axios.$put(`/interfaceApi/procurement/stock_grid_check/confirm/${id}?DuringInStockVolume=${DuringInStockVolume}&DuringOutStockVolume=${DuringOutStockVolume}`);
        },

        returnConfirmFormInfoRequrst(id) {
            return this.$axios.$put(`/interfaceApi/procurement/stock_grid_check/back/${id}`);
        },

        saveRemarksRequrst(id, Remarks) {
            return this.$axios.$put(`/interfaceApi/procurement/stock_grid_check/modify_remark/${id}`, `"${Remarks}"`);
        },
    },
};
</script>
<style lang="stylus">
.monitorTheInventoryConfirmForm
    .formList
        &.formList_Readonly
            height calc(100% - 44rpx)
        li
            .materialItem
                margin: 12rpx
                border 1px solid #E7E6E6
                border-radius 4rpx
                color #1f2229
                overflow hidden
                dt
                    display: flex
                    align-items: center
                    flex-wrap: wrap
                    justify-content: space-between
                    border-bottom 1px solid #E7E6E6
                    background: #F8F8F8
                    font-size 16rpx
                    p
                        min-width 50%
                        padding 5rpx 12rpx
                dd
                    display: flex
                    align-items: center
                    justify-content: space-between
                    padding 14rpx
                    div
                        font-size 14rpx
                        margin-right 14rpx
                        flex 1
                        &:last-child
                            margin-right 0
                        h5
                            color #626262
                            margin-bottom: 6rpx
                        p
                            height 32rpx
                            line-height 32rpx
                            padding 0 14rpx
                            background: #F8F8F8
                        &.difference
                            h5
                                color #FF3A03
                            p
                                background: #FFF7F3
                                color #FF3A03
</style>